import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./hrmTour.css";

export function startHrmDashboardTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh Dashboard HRM",
        description: "Xem nhanh bộ lọc, KPI, biểu đồ chấm công/tăng ca theo ngày và bảng nghỉ phép & công tác.",
        side: "over",
        align: "center",
      },
    },
  ];
  const segments = [
    ['[data-tour="hrm-dashboard-header"]', "Tiêu đề và tổng quan", "Đây là màn tổng hợp dữ liệu nhân sự theo thời gian và chi nhánh.", "bottom"],
    ['[data-tour="hrm-dashboard-filters"]', "Bộ lọc dashboard", "Super Admin có thể chọn chi nhánh; mọi user chọn một tháng (năm + tháng) để cập nhật số liệu.", "left"],
    ['[data-tour="hrm-dashboard-kpis"]', "Thẻ KPI", "Super Admin xem thêm 4 thẻ tổ chức (chi nhánh, nhân viên, GV thỉnh giảng, kế hoạch). Mọi vai trò xem 4 thẻ vận hành: công việc, giờ chấm công, giờ tăng ca, tổng ngày nghỉ & công tác trong tháng.", "bottom"],
    ['[data-tour="hrm-dashboard-charts"]', "Biểu đồ theo ngày", "Chấm công và tăng ca theo từng ngày trong tháng (cùng kiểu biểu đồ với màn Chấm công / Tăng ca).", "top"],
    ['[data-tour="hrm-dashboard-recent"]', "Nghỉ phép & công tác", "Bảng đơn trong tháng: nhân viên, loại đơn, thời gian, số ngày trong phạm vi tháng, trạng thái.", "top"],
  ];
  for (const [selector, title, description, side] of segments) {
    const el = document.querySelector(selector);
    if (!el) continue;
    steps.push({ element: el, popover: { title, description, side } });
  }
  if (steps.length <= 1) return window.alert("Không tìm thấy vùng để chạy hướng dẫn.");
  driver({
    showProgress: true,
    smoothScroll: true,
    popoverClass: "hrm-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    steps,
  }).drive();
}
